module.exports = __webpack_public_path__ + "img/bookmrk.59da46bd.svg";